import { useState } from "react";
import { Check, ChevronDown } from "lucide-react";
import { APPOINTMENT_STATUSES, APPOINTMENT_STATUS_COLORS, APPOINTMENT_STATUS_LABELS, type AppointmentStatus } from "@bookdental/schemas";
import { Popover, PopoverContent, PopoverTrigger } from "@bookdental/ui";

/** Pílula do status no título do diálogo; abre a lista de status. */
export function StatusDaConsulta({ value, onChange }: { value: AppointmentStatus; onChange: (s: AppointmentStatus) => void }) {
  const [open, setOpen] = useState(false);
  const color = APPOINTMENT_STATUS_COLORS[value];
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="group inline-flex items-center gap-1.5 rounded-full py-1 pl-2 pr-2.5 text-[11px] font-bold uppercase tracking-wide outline-none transition-colors"
          style={{ backgroundColor: `${color}1a`, color, boxShadow: `inset 0 0 0 1px ${color}66` }}
        >
          <span className="h-1.5 w-1.5 shrink-0 rounded-full" style={{ backgroundColor: color }} />
          <span className="truncate">{APPOINTMENT_STATUS_LABELS[value]}</span>
          <ChevronDown className="h-3 w-3 shrink-0 opacity-70 transition-transform group-data-[state=open]:rotate-180" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        sideOffset={6}
        className="w-56 overflow-hidden rounded-xl border border-zinc-200 bg-white p-1 shadow-xl dark:border-border dark:bg-card"
      >
        <div className="px-2 pb-1 pt-1 text-[10px] font-bold uppercase tracking-wider text-zinc-500 dark:text-muted-foreground">Status da consulta</div>
        <ul className="space-y-0.5">
          {APPOINTMENT_STATUSES.map((s) => {
            const c = APPOINTMENT_STATUS_COLORS[s];
            const active = s === value;
            return (
              <li key={s}>
                <button
                  type="button"
                  onClick={() => {
                    onChange(s);
                    setOpen(false);
                  }}
                  className="flex w-full items-center gap-2.5 rounded-lg px-2 py-1.5 text-left text-[12.5px] font-medium text-zinc-700 transition-colors hover:bg-zinc-50 dark:text-foreground dark:hover:bg-muted/40"
                >
                  <span className="h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: c }} />
                  <span className={active ? "flex-1 font-semibold" : "flex-1"}>{APPOINTMENT_STATUS_LABELS[s]}</span>
                  {active && <Check className="h-3.5 w-3.5 text-brand-600 dark:text-primary" />}
                </button>
              </li>
            );
          })}
        </ul>
      </PopoverContent>
    </Popover>
  );
}
